import { InputPadrao, InputSwitch } from '../../../../components/Inputs'
import React, { useState, useEffect } from 'react'
import { Formik, Form } from "formik"
import { mostrarToast } from '../../../../components/Toasts'
import { BotaoPadrao } from '../../../../components/Botoes'
import { get, salvar } from '../../../../util/AcessoApi'
import { Link, useParams } from "react-router-dom"
import { mensagens } from '../../../../util/Utilitarios'
import Yup from '../../../../util/Validacoes'
import '../../../../assets/css/ios-switch/clean-switch.css'
import 'react-circular-progressbar/dist/styles.css'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import Atalho from '../../../../util/Atalho'
import { HeaderCadastro } from '../../../../components/Headers'

const CadastroTipoOcorrencia = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [validacao] = useState(Yup.object({
        sigla: Yup.string().required().nullable().max(5),
        descricao: Yup.string()
            .required().nullable().trim()
            .max(200)
    }))

    const manter = []

    const Submit = (values, propsFormik) => {
        setSalvando(true)

        salvar(
            values,
            '/administracao/tipo-ocorrencia',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (salvarENovo) {
                    propsFormik.resetForm({})
                    // manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                    setSalvando(false)
                    setSalvarENovo(false)
                }
                else
                    props.history.push('/administracao/tipo-ocorrencia/consulta')

                setSalvando(false)
            }, (err) => {
                console.log('err: ', err);
                mostrarToast('erro', mensagens.erro)
                setSalvando(false)
            })
    }


    useEffect(_ => {
        if (!props.modal && id) {

            Promise.resolve(get(`/administracao/tipo-ocorrencia/${id}`)).then(obj => {
                setValoresIniciais(obj)
            })
        } else {
            setValoresIniciais({
                descricao: '',
                sigla: ''

            })
        }
    }, [id])

    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>Administrativo</span>,
        () => <Link className='link-active' to={'/administracao/tipo-ocorrencia/consulta'}>Tipo Ocorrência</Link>,
    ]


    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => (<Form>
                {!props.modal && <HeaderCadastro titulo={"Cadastro Tipo Ocorrência"}  link={links}/>}
                <div className={props.modal && props.modal || 'card mb-20'}>
                    <div className={'card-body'}>
                        <div className='row'>
                            {/* <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' obrigatorio={false} /> */}
                            <InputPadrao autoFocus label='Tipo Ocorrência' name='descricao' type='text' placeholder='Tipo Ocorrência' obrigatorio={true} tamanho='col-7 col-xl-7 col-sm-12' salvarENovo={salvarENovo} />
                            <InputPadrao maxLength={5} tamanho={!props.modal && 'col-1 col-xl-1 col-sm-12'} label="Sigla" name="sigla" type="text" placeholder="Sigla" classeTooltip={props.modal && 'tooltip-input-modal'} obrigatorio={true} />
                            <InputSwitch label='Mapa de Horas?' propsFormik={propsFormik} quebrarLinha name='compoe_mapa_horas' size="md" tamanho={'col-lg-1 '} classeTooltip={props.modal && 'tooltip-input-modal'} classeDiv='form-group ajusta-switch-operadora '/>


                        </div>
                    </div>
                </div>
                {!props.modal && <div className='separator mt-40 mb-5'></div>}
                <div className='direita container-botoes mb-3 group-salvar-novo'>
                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                    {(props.modal || !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
                    
                </div>
            </Form>)}
        </Formik>
    );
}

export default CadastroTipoOcorrencia 
